import { App } from '@capacitor/app'
import { ignoreErrors, processAPIEnv, SentryInitParameters } from '.'
import * as Sentry from '@sentry/capacitor'
import * as SentryVue from '@sentry/vue'

export const sentryNativeInit = async (initParams: SentryInitParameters) => {
  //see: https://docs.sentry.io/platforms/javascript/guides/capacitor/
  const version = (await App.getInfo()).version
  const name = (await App.getInfo()).name
  console.log(`${name}@${version}`)

  Sentry.init(
    {
      app: initParams.app,
      dsn: 'https://af37160758e4457f800a14484e39f520@o1065306.ingest.sentry.io/4504476606070784',
      // release: `${name}@${version}`, //e.g. fhs@1.12.0
      // This sets the sample rate to be 5%. You may want this to be 100% while
      // in development and sample at a lower rate in production
      replaysSessionSampleRate: 0.05,

      // If the entire session is not sampled, use the below sample rate to sample
      // sessions when an error occurs.
      replaysOnErrorSampleRate: 0.5,
      integrations: [
        SentryVue.browserTracingIntegration(),
        SentryVue.replayIntegration({
          // Additional SDK configuration goes in here, for example:
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
      tracesSampler: (samplingContext) => {
        if (process.env.API_URL && processAPIEnv(process.env.API_URL) == 'production') {
          return 0.25
        }
        // Sample 20% in testing envs
        return 1.0
      },
      maxValueLength: 5000,
      maxBreadcrumbs: 40,
      normalizeDepth: 5,
      environment: process.env.API_URL ? processAPIEnv(process.env.API_URL) : 'development',
      ignoreErrors: ignoreErrors,
      beforeSendTransaction(event, hint) {
        if (event.transaction === 'Sync') {
          delete event.breadcrumbs
        }
        return event
      },
    },
    SentryVue.init
  )
  Sentry.setContext('user info', {
    status: 'Not logged in yet',
  })
}
